import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgc4thfmq4: FaireProductEntity = {
  token: "p_mgc4thfmq4",
  type: "product",
  name: "Botanical Bath Salt Gift Set | Luxury Spa Gift Box",
  brandName: "Hera By Hera Bath and Body",
  imageUrl:
    "https://cdn.faire.com/fastly/e7ab1a4b376a9398b6483fd4355391692c468fe1761dbb46629b751a0e26ae30.jpeg",
  priceDollars: 33,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2469096c2e6c58adcb937bfed63bdb1f3534c7df0330c71ada3f7c1eaeb8beff.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
